import { Button, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const MfaSelectRadioIcon = styled("span")(({ theme }) => ({
  ".Mui-checked &": {
    "&::after": {
      backgroundColor: theme.customColors.backgroundPrimaryCta,
      borderRadius: "50%",
      content: "\"\"",
      height: theme.spacing(1),
      width: theme.spacing(1)
    },
    backgroundColor: theme.customColors.backgroundPrimaryControl
  },
  alignItems: "center",
  backgroundColor: theme.customColors.backgroundDisabled,
  border: `1px solid ${theme.customColors.border}`,
  borderRadius: "50%",
  boxSizing: "border-box",
  display: "inline-flex",
  height: theme.spacing(2.5),
  justifyContent: "center",
  width: theme.spacing(2.5)
}));

export const MfaSelectActions = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  gap: theme.spacing(2),
  width: "100%",

  [theme.breakpoints.down("sm")]: {
    flexDirection: "column"
  }
}));

export const MfaSelectButton = styled(Button)(({ theme }) => ({
  "&.Mui-focusVisible": {
    outline: `2px solid ${theme.customColors.borderAccent}`,
    outlineOffset: theme.spacing(0.5)
  },
  "&.MuiButton-contained": {
    "&.Mui-disabled": {
      backgroundColor: theme.customColors.backgroundDisabledAlternative,
      color: theme.customColors.textDisabled
    },
    "&:hover": {
      backgroundColor: theme.customColors.backgroundPrimaryCtaHover,
      boxShadow: "none"
    },
    backgroundColor: theme.customColors.backgroundPrimaryCta,
    boxShadow: "none",
    color: theme.customColors.textPrimaryCta
  },
  "&.MuiButton-outlined": {
    "&:hover": {
      backgroundColor: theme.customColors.backgroundSecondaryCtaHover
    },
    border: `2px solid ${theme.customColors.textPrimary}`,
    color: theme.customColors.textPrimary
  },
  borderRadius: theme.shape.borderRadius * 2,
  fontSize: theme.typography.pxToRem(14),
  fontWeight: theme.typography.fontWeightBold,
  lineHeight: 1.5,
  minHeight: theme.spacing(5),
  padding: theme.spacing(0.75, 2),
  textTransform: "none",
  width: "100%"
}));
